import { getGapForIndex } from '../../../../utilities/getGapForIndex.js';

function getXPosition({
  start,
  end,
  seriesIndex,
  gaps,
  xScale
}) {
  if (start < 0) {
    return xScale(start) - getGapForIndex({
      gaps,
      direction: 'negative',
      seriesIndex
    });
  }

  if (end > 0) {
    return xScale(start) + getGapForIndex({
      gaps,
      direction: 'positive',
      seriesIndex
    });
  }

  return xScale(start);
}

export { getXPosition };
